import { Form, Text, TextVariants } from "@centricsoftware/design-system";
import { useSetRefOnMount } from "csi/components/hooks";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { IForm } from "src/c8-platform/type/form";
import { useFormStore } from "../FormStore";
import css from "./StatefulForm.module.css";
import { StatefulFormField } from "./StatefulFormField";

interface StatefulFormProps {
	formInfo: IForm;
}

export const StatefulForm: FunctionComponent<StatefulFormProps> = observer(function StatefulForm({ formInfo }) {
	const { formErrorMessage, setFormRef } = useFormStore();
	const formRef = useSetRefOnMount<HTMLFormElement>(setFormRef);

	return (
		<Form
			autoComplete="off"
			isFullWidth
			noValidate
			ref={formRef}
		>
			{formErrorMessage && (
				<span className={css.errorBanner}>
					<Text dataCsiAutomation="ErrorMessage" variant={TextVariants.UiSemibold}>
						{formErrorMessage}
					</Text>
				</span>
			)}
			{formInfo.fields.map((f) => (
				<StatefulFormField
					field={f}
					key={f.id}
					nodeType={formInfo.nodeType}
					nodeUrl={formInfo.nodeUrl}
					reportOperations={formInfo.reportOperations}
				/>
			))}
		</Form>
	);
});
